import { render, staticRenderFns } from "./InventoryStateSwitchConfig.vue?vue&type=template&id=52af7d45&scoped=true"
import script from "./InventoryStateSwitchConfig.vue?vue&type=script&lang=js"
export * from "./InventoryStateSwitchConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52af7d45",
  null
  
)

export default component.exports